import EmployeesLandingContainer from './EmployeesLandingContainer';

export { EmployeesLandingContainer };
